<template>
  <modal :show="showDeleteModal" modal-classes="modal-secondary" size="lg" @close="$emit('modal-product-delete-dismiss')">
    <h5 slot="header" class="modal-title">
      {{ product ? product.item.n : "" }}
    </h5>
    <div>
      Deseja excluir o produto? Após esta ação não será possível modificar o
      produto ou o estoque já comprado
    </div>
    <template slot="footer">
      <b-button type="button" variant="link" class="ml-auto"
        @click="$emit('modal-product-delete-dismiss')">Voltar</b-button>
      <b-button type="button" variant="primary" class="new-event--add" @click="deleteProduct">Excluir</b-button>
    </template>
  </modal>
</template>
<script>
import Modal from "@/components/Modal";
import bocapioService from "./../../services/nodejs/index";
import swal from "sweetalert2";
import "sweetalert2/dist/sweetalert2.css";

export default {
  name: "modal-product-delete",
  components: {
    Modal,
  },
  props: {
    showDeleteModal: {
      type: Boolean,
      default: false,
    },
    product: {
      type: Object,
      default: null,
    },
  },
  methods: {
    deleteProduct() {
      const { item, row } = this.product;
      bocapioService.deleteProduct(item.id).then(() => {
        this.$emit("modal-product-delete-action", row);
        swal.fire({
          title: "Sucesso",
          text: "Produto excluído com sucesso",
          buttonsStyling: false,
          confirmButtonClass: "btn btn-primary",
          cancelButtonClass: "btn btn-primary",
          icon: "success",
        });
      });
      // .catch((erro) => {
      //   swal.fire({
      //     title: "Erro",
      //     text: "Erro ao excluir o produto",
      //     buttonsStyling: false,
      //     confirmButtonClass: "btn btn-warning",
      //     icon: "warning",
      //   });
      // });
    },
  },
};
</script>
<style></style>